import { useEffect } from 'react';
const useDispatchForContextSideEffect = (contextDispatch, type, payload, dependencies = payload) => {
  return useEffect(() => {
    contextDispatch({
      type,
      payload
    });
  }, [dependencies]);
};
export default useDispatchForContextSideEffect;
//# sourceMappingURL=useDispatchForContextSideEffect.js.map